
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community-projects",
      function () {
        return require("private-next-pages/community-projects/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community-projects"])
      });
    }
  